const arabicToThai = () => {
  const convertToThaiNumerals = (text) => {
    const arabicToThai = {
      0: "๐",
      1: "๑",
      2: "๒",
      3: "๓",
      4: "๔",
      5: "๕",
      6: "๖",
      7: "๗",
      8: "๘",
      9: "๙",
    };
    return text.replace(/[0-9]/g, (match) => arabicToThai[match]);
  };

  const toThaiWord = (num) => {
    const words = [
      "ศูนย์",
      "หนึ่ง",
      "สอง",
      "สาม",
      "สี่",
      "ห้า",
      "หก",
      "เจ็ด",
      "แปด",
      "เก้า",
    ];
    return num
      .toString()
      .split("")
      .map((d) => words[parseInt(d)])
      .join("");
  };

  const numberToThaiText = (number) => {
    // ลบคอมม่าออก และแปลงเป็น string
    number = number.toString().replace(/,/g, "");

    // แยกส่วนบาท และ สตางค์
    let [baht, satang] = number.split(".");
    satang = satang ? satang.substring(0, 2) : "0";

    const thaiNum = [
      "ศูนย์",
      "หนึ่ง",
      "สอง",
      "สาม",
      "สี่",
      "ห้า",
      "หก",
      "เจ็ด",
      "แปด",
      "เก้า",
    ];
    const thaiPos = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

    function convertToThai(numStr) {
      let result = "";
      const numArray = numStr.split("").reverse();
      for (let i = 0; i < numArray.length; i++) {
        const n = parseInt(numArray[i]);
        if (n !== 0) {
          let word = thaiNum[n];
          if (i === 0 && n === 1 && numArray.length > 1) word = "เอ็ด";
          if (i === 1 && n === 2) word = "ยี่";
          if (i === 1 && n === 1) word = ""; // "สิบ"
          result = word + thaiPos[i] + result;
        }
      }
      return result;
    }

    // แปลงส่วนบาท
    let bahtText = "";
    if (parseInt(baht, 10) === 0) {
      bahtText = "ศูนย์บาท";
    } else {
      const bahtParts = baht.split(/(?=(?:\d{6})+$)/); // แบ่งส่วนล้าน
      for (let i = 0; i < bahtParts.length; i++) {
        const part = parseInt(bahtParts[i], 10);
        if (part !== 0) {
          bahtText +=
            convertToThai(bahtParts[i]) +
            (i < bahtParts.length - 1 ? "ล้าน" : "");
        }
      }
      bahtText += "บาท";
    }

    // แปลงส่วนสตางค์
    let satangText = "";
    if (parseInt(satang, 10) === 0) {
      satangText = "ถ้วน";
    } else {
      satangText = convertToThai(satang) + "สตางค์";
    }

    return bahtText + satangText;
  };
  return [convertToThaiNumerals, toThaiWord, numberToThaiText];
};

export default arabicToThai;
